import { type ForwardedRef, forwardRef } from 'react'
import type { PatternFormatProps } from 'react-number-format'
import { PatternFormat } from 'react-number-format'

import type { InputProps } from '@/_components/ui/input'
import { Input } from '@/_components/ui/input'

type PhoneInputProps = Omit<Partial<PatternFormatProps<InputProps>>, 'onChange'> & {
  onChange?: (value: string) => void
}

export const PhoneInput = forwardRef(
  ({ onChange, ...props }: PhoneInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <PatternFormat
        {...props}
        format="(##) #####-####"
        autoComplete="tel-national"
        customInput={Input}
        getInputRef={ref}
        placeholder="(99) 99999-9999"
        onValueChange={(values) => {
          onChange?.(values.value)
        }}
      />
    )
  },
)

PhoneInput.displayName = 'PhoneInput'
